const OAuthShareConnectPage = () =>
  import(
    /* webpackChunkName: "oauth-share-connect" */ '@/modules/public/oauthshare/OAuthShareConnectPage.vue'
  );
const OAuthShareSuccessPage = () =>
  import(
    /* webpackChunkName: "oauth-share-success" */ '@/modules/public/oauthshare/OAuthShareSuccessPage.vue'
  );
const OAuthShareErrorPage = () =>
  import(
    /* webpackChunkName: "oauth-share-error" */ '@/modules/public/oauthshare/OAuthShareErrorPage.vue'
  );

export const OAuthSharePathName = {
  CONNECT: 'oauthshareconnect',
  SUCCESS: 'oauthsharesuccess',
  ERROR: 'oauthshareerror',
};

export const oauthShareRoutes = [
  {
    path: '/oauth-share/success',
    name: OAuthSharePathName.SUCCESS,
    component: OAuthShareSuccessPage,
  },
  {
    path: '/oauth-share/error',
    name: OAuthSharePathName.ERROR,
    component: OAuthShareErrorPage,
  },
  {
    path: '/oauth-share/:token',
    name: OAuthSharePathName.CONNECT,
    component: OAuthShareConnectPage,
  },
];
